import styles from "../../../../../styles.config";

export default {
    chart: {
        animations: {
            enabled: false,
        },
        type: 'bar',
        redrawOnParentResize: true,
        selection: {
            stroke: {
                width: 1,
            }
        },
        fontFamily: styles.fontFamily.sans,
        toolbar: {
            tools: {
                download: `
                    <button
                        class="rounded-32 flex flex-none items-center justify-center direction-column absolute"
                    >
                        <svg class="w-24 h-24 block !fill-primary flex-none">
                            <use xlink:href="#download" />
                        </svg>
                    </button>
                `,
                selection: false,
                zoom: false,
                zoomin: false,
                zoomout: false,
                pan: false,
                reset: false,
            }
        }
    },
    dataLabels: {
        enabled: true,
    },
    plotOptions: {
        bar: {
            horizontal: true,
        },
    },
    stroke: {
        colors: ['transparent'],
        width: 2,
    },
    theme: {
        palette: 'palette1',
    },
    style: {
        fontFamily: styles.fontFamily.sans,
    },
    xaxis: {
        type: 'category',
        categories: []
    },
    yaxis: {
        labels: {
            maxWidth: 150,
            offsetY: 2.5,
        }
    },
    tooltip: {
        fixed: {
            enabled: false
        }
    },
    legend: {
        position: 'top',
        markers: {
            width: 18,
            height: 18,
            radius: 4,
            offsetY: 4.5,
        }
    }
}
